// extracted by mini-css-extract-plugin
export var featureColumn = "PermissionMatrix-module--featureColumn--AWbZ4";
export var field = "PermissionMatrix-module--field--S-va3";
export var header = "PermissionMatrix-module--header--htKcS";
export var permColumn = "PermissionMatrix-module--permColumn--Qgb5S";